module.exports = __webpack_public_path__ + "img/night-top-bg_ms.636d3b83.png";